import React from 'react';
import { Box } from '@common-fe/common-fe';

import theme from '@/styles/theme';

interface Props {
  children: React.ReactNode;
}

const TableHeaderWrapper: React.FC<Props> = ({ children }) => {
  return (
    <Box
      margin={{ top: 's', bottom: 'xs' }}
      pad={{ horizontal: 'm', vertical: '7px' }}
      background="legend"
      round="container2Round"
      width="100%"
      height="32px"
      direction="column"
      justify="center"
    >
      <Box
        style={{
          fontSize: '12px',
          fontWeight: 'bold',
          lineHeight: '18px',
          color: theme.colors.textBody,
        }}
        direction="row"
        height="18px"
      >
        {children}
      </Box>
    </Box>
  );
};

export default TableHeaderWrapper;
